// extracted by mini-css-extract-plugin
export default {"error-wrapper":"ErrorMessage_error-wrapper__4+26f"};